const Background = ({ children }) => {
  return <>{children}</>;
};

export default Background;
